/** @format */

import { ActionReducerMap } from '@ngrx/store';
import { ProductSocialContentState } from '../../model';
import { productSocialContentReducer } from './product-social-content.reducer';

export interface AppProductSocialContentState {
	productSocialContentState: ProductSocialContentState;
}

export const productReviewReducers: ActionReducerMap<AppProductSocialContentState> = {
	productSocialContentState: productSocialContentReducer
};
